import axios from "axios";
import { auth, getAppCheckHeader } from "./main";

let Axios = axios;
const init = () => {
  Axios = axios.create({
    baseURL: `${process.env.VUE_APP_BASEURL}/api/`,
    timeout: 60000,
  });
  Axios.interceptors.request.use(handleSuccessRequest, handleErrorRequest);
  Axios.interceptors.response.use(handleSuccess, handleError);
};

const handleSuccessRequest = async (request) => {
  const user = auth.currentUser;

  Object.assign(request.headers, await getAppCheckHeader());

  if (user) {
    const token = await user.getIdToken();
    request.headers["Authorization"] = `Bearer ${token}`;
  } else {
    delete request.headers["Authorization"];
  }

  return request;
};

const handleErrorRequest = (error) => {
  return Promise.reject(error);
};

const handleSuccess = (response) => {
  return response.data;
};

const handleError = async (error) => {
  if (error.response && error.response.status === 401) {
    await auth.signOut();
    window.location.href = '/login';
  }
  return Promise.reject({status: error.response.status, ...error.response.data});
};

init();

export default Axios;